// import Common from "./0_common";

function TopFeatureDemo() {
  const self = this;

  this.list = $("#js-top-feature-demo");
  this.list_num = $("#js-top-feature-demo li").length;
  this.imagePC = $("#js-top-feature-demo-image-pc");
  this.imageSP = $("#js-top-feature-demo-image-sp");
  this.imageSRC = "/static/service/images/top/pic-about";
  this.now_num = 0;
  this.step_pc = 292;
  this.step_sp = (100 * 535) / 750;

  var item1 = this.list.find("li").eq(0);
  var item2 = this.list.find("li").eq(1);
  var item3 = this.list.find("li").eq(2);
  item1.clone(true).appendTo(this.list);
  item2.clone(true).appendTo(this.list);
  item3.clone(true).appendTo(this.list);

  setTimeout(function() {
    self.check();
  }, 3000);
}

module.exports.TopFeatureDemo = TopFeatureDemo;

TopFeatureDemo.prototype.check = function() {
  this.now_num++;
  if (this.now_num == this.list_num + 1) {
    this.now_num = 0;
    this.reset();
  } else {
    this.next();
  }
};

TopFeatureDemo.prototype.next = function() {
  const self = this;
  this.list.addClass("smooth");
  this.imagePC.removeClass("show");
  this.imageSP.removeClass("show");
  let srcNum = this.now_num + 2;
  if (srcNum > this.list_num) {
    srcNum = srcNum - this.list_num;
  }
  if (!this.isSP()) {
    var nextPos = this.step_pc * this.now_num;
    var nextStyle = "translate3d(0,-" + nextPos + "px,0)";
  } else {
    var nextPos = this.step_sp * this.now_num;
    var nextStyle = "translate3d(-" + nextPos + "vw,0,0)";
  }

  this.list.css("transform", nextStyle);
  const nextImageSrcPC = this.imageSRC + srcNum + "-pc.jpg";
  const nextImageSrcSP = this.imageSRC + srcNum + "-sp.jpg";

  setTimeout(function() {
    self.imagePC.attr("src", nextImageSrcPC);
    self.imageSP.attr("src", nextImageSrcSP);

    setTimeout(function() {
      self.imagePC.addClass("show");
      self.imageSP.addClass("show");
    }, 100);
  }, 500);

  setTimeout(function() {
    self.check();
  }, 3000);
};

TopFeatureDemo.prototype.reset = function() {
  const self = this;
  this.list.removeClass("smooth");
  const nextStyle = "translate3d(0,0,0)";
  this.list.css("transform", nextStyle);
  setTimeout(function() {
    self.check();
  }, 50);
};

TopFeatureDemo.prototype.isSP = function() {
  if ($(window).width() < 750) {
    return true;
  } else {
    return false;
  }
};
